<template>
    <div id="ContainerNotifications">
        <div class="page-height">
            <div class="col-12">
                <h4 v-if="this.$attrs.editMode" class="page-title text-truncate">
                    {{ $t('notifications.Edit') }}
                </h4>
                <h4 v-if="!this.$attrs.editMode" class="page-title text-truncate">
                    {{ $t('notifications.Add') }}
                </h4>
                <b-row class="mt-3">
                    <b-col lg="12" md="12" sm="12">
                        <fieldset class="customWells">
                            <legend>
                                {{ $t('notificationsList.Listing.eType') }}
                            </legend>
                            <MdRadioGroup
                                v-model="notificationData.notificationType"
                                v-bind:Options="notificationTypes"
                                v-bind:Name="'radioGroup-notificationTypes'"
                                v-bind:Stacked="false"
                                :isReadOnly = "this.$attrs.editMode"
                            />
                        </fieldset>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="6" md="6" sm="12">
                        <MdTitle
                            v-bind:Text="$t('notifications.eGeneralSetup')"
                            v-bind:isSubtitle="true"
                            v-bind:Name="'T_TitleGeneralSetup'"
                        />
                    </b-col>
                    <b-col lg="6" md="6" sm="12">
                        <MdTitle
                            v-bind:Text="$t('notifications.eAPISetup')"
                            v-bind:isSubtitle="true"
                            v-bind:Name="'T_TitleeAPISetup'"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="6" md="6" sm="12">
                        <MdEdit
                            v-model="notificationData.hostName"
                            v-bind:Label="$t('notifications.eHostName')"
                            v-bind:MaxLengthProp="255"
                        />
                    </b-col>
                    <b-col lg="6" md="6" sm="12">
                        <MdCheckBox
                            v-bind:Label="$t('notifications.eUseAPI')"
                            v-bind:ClassProp="'AlignCheck'"
                            v-bind:CheckedValue="'Y'"
                            v-bind:UncheckedValue="'N'"
                            v-model="notificationData.useApi"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="6" md="6" sm="12">
                        <MdEdit
                            v-model.number="notificationData.portNo"
                            v-bind:Label="$tc('notifications.ePortNo')"
                            v-bind:Placeholder="''"
                            v-bind:TypeProp="'number'"
                            v-bind:Min="'1'"
                            v-bind:Max="'65535'"
                        />
                    </b-col>
                    <b-col lg="6" md="6" sm="12">
                        <div :style="notificationData.useApi !== 'Y' ? 'pointer-events: none; opacity: 0.6;' : ''">
                            <MdEdit
                                v-model="notificationData.apiUrl"
                                v-bind:Label="$t('notifications.eApiUrl')"
                                v-bind:MaxLengthProp="255"
                            />
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="6" md="6" sm="12">
                        <MdEdit
                            v-model="notificationData.userId"
                            v-bind:Label="$t('notifications.eUserID')"
                            v-bind:MaxLengthProp="255"
                        />
                    </b-col>
                    <b-col lg="6" md="6" sm="12">
                        <div :style="notificationData.useApi !== 'Y' ? 'pointer-events: none; opacity: 0.6;' : ''">
                            <MdEdit
                                v-model="notificationData.apiname"
                                v-bind:Label="$t('notifications.eApiName')"
                                v-bind:MaxLengthProp="255"
                            />
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="6" md="6" sm="12">
                        <MdEdit
                            v-model="notificationData.userPassword"
                            v-bind:Label="$t('notifications.ePassword')"
                            v-bind:MaxLengthProp="255"
                        />
                    </b-col>
                    <b-col lg="6" md="6" sm="12">
                        <div :style="notificationData.useApi !== 'Y' ? 'pointer-events: none; opacity: 0.6;' : ''">
                            <MdEdit
                                v-model="notificationData.apiuserId"
                                v-bind:Label="$t('notifications.eApiAuthID')"
                                v-bind:MaxLengthProp="255"
                            />
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="6" md="6" sm="12">
                        <MdEdit
                            v-model="notificationData.senderName"
                            v-bind:Label="$t('notifications.eSenderName')"
                            v-bind:MaxLengthProp="255"
                        />
                    </b-col>
                    <b-col lg="6" md="6" sm="12">
                        <div :style="notificationData.useApi !== 'Y' ? 'pointer-events: none; opacity: 0.6;' : ''">
                            <MdEdit
                                v-model="notificationData.apipassword"
                                v-bind:Label="$t('notifications.eApiAuthToken')"
                                v-bind:MaxLengthProp="255"
                            />
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="6" md="6" sm="12">
                        <MdEdit
                            v-model="notificationData.senderEmail"
                            v-bind:Label="$t('notifications.eSenderEmail')"
                            v-bind:MaxLengthProp="255"
                        />
                    </b-col>
                    <b-col lg="6" md="6" sm="12">
                        <div :style="notificationData.useApi !== 'Y' ? 'pointer-events: none; opacity: 0.6;' : ''">
                            <MdEdit
                                v-model="notificationData.apisenderNumber"
                                v-bind:Label="$t('notifications.eApiSenderNumber')"
                                v-bind:MaxLengthProp="255"
                            />
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="6" md="6" sm="12">
                        <b-row>
                            <b-col lg="6" md="6" sm="12">
                                <b-col md="6" lg="6" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="$t('notifications.eUseSSL')"
                                        v-bind:Name="'checkbox-notifications.eUseSSL'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="'Y'"
                                        v-bind:UncheckedValue="'N'"
                                        v-model="notificationData.useSsl"
                                    />
                                </b-col>
                            </b-col>
                            <b-col lg="6" md="6" sm="12">
                                <b-col md="6" lg="6" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="$t('notifications.eUseTLS')"
                                        v-bind:Name="'checkbox-notifications.eUseTLS'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="'Y'"
                                        v-bind:UncheckedValue="'N'"
                                        v-model="notificationData.useTls"
                                    />
                                </b-col>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col lg="6" md="6" sm="12"></b-col>
                </b-row>

                <div class="space-actions"></div>
            </div>
            <div class="page-actions">
                <MdButton
                    v-bind:Label="$t('Shared.Back')"
                    v-bind:Name="'btn_notifications_list'"
                    v-bind:ClassProp="'secondary mx-2 btn-login'"
                    v-on:click="DiscardChanges"
                />
                <MdButton
                    v-bind:Label="$t('Shared.Save')"
                    v-bind:ClassProp="
                        this.isReadOnlyNotifications ? 'primary mx-2' : 'primary btn-login mx-2'
                    "
                    v-on:click="SaveOrEdit"
                    v-bind:isReadOnly="isReadOnlyNotifications"
                    v-bind:Name="'btn_save_notifications'"
                />
            </div>
        </div>
    </div>
</template>

<script>
import DBFunctions from '@/common/DBFunctions.js';
import ShowMessage from '@/components/messages/ShowMessage.js';
import NotificationsService from '@/services/notifications.service';
import { EventBus } from '../../../../event-bus.js';
import Permission from '@/common/Permission';

let elemSaveBtn = '';
export default {
    beforeRouteLeave(to, from, next) {
        if (this.pendingChanges) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                    title: this.$t('Admission.Admission'),
                    okTitle: this.$t('Shared.BtnSave'),
                    cancelTitle: this.$t('Shared.BtnDismiss'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(async value => {
                    if (!value) {
                        next();
                    } else {
                        await this.SaveOrEdit();
                        next();
                    }
                });
        } else {
            next();
        }
    },

    name: 'NOTIFICATIONS',
    mixins: [ShowMessage, DBFunctions, Permission /*,EventBus*/],
    data() {
        return {
            parameter: {
                SearchCriteria: '',
                PageNumber: 1,
                PageSize: 0
            },
            pendingChanges: false,

            notificationData: {
                hostName: '',
                portNo: 0,
                userId: '',
                userPassword: '',
                senderName: '',
                senderEmail: '',
                notificationType: '',
                useApi: 'N',
                useSsl: 'N',
                useTls: 'N',
                apiUrl: '',
                apiuserId: '',
                apipassword: '',
                apisenderNumber: '',
                apiname: '',
                recId: 0
            },

            notificationTypes: [
                { text: this.$t('notifications.Types.All'), value: 'ALL' },
                { text: this.$t('notifications.Types.Email'), value: 'EMAIL' },
                { text: this.$t('notifications.Types.Text'), value: 'TEXT' }
            ],

            isReadOnlyNotifications: false,

            OptionsRightMenu: {
                visible: false,
                ItemsList: [],
                btnvisible: false,
                itemdisabled: false,
                PatientCode: '',
                Mode: this.edit_mode,
                favButtonAtion: false
            }
        };
    },

    methods: {
        DiscardChanges() {
            this.checkExistFavorite('/app/notificationss');
            this.$router.push({ name: 'notificationsList' });
        },

        getNotifications() {
            if (this.$attrs.editMode) {
                NotificationsService.Get(this.$route.params.id)
                    .then(response => {
                        if (response.status == '200' && response.data) {
                            this.notificationData = response.data;
                        }
                    })
                    .catch(error => {
                        if (!error.response) {
                            this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.retrieveInfo'), 'error');
                        } else if (error.response.status === 400) {
                            this.showMessage(this.$tc('Msg.Error'), error.response.data.errorMessage, 'error');
                        } else if (error.response.status === 405) {
                            this.$router.push({ name: 'Main' });
                            setTimeout(() => this.showPermissionMessage(), 50);
                        } else if (error.response.status === 500) {
                            this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.ThereWereSomeError'), 'error');
                        } else {
                            this.showMessage(this.$tc('Msg.Error'), error.response.data.errorMessage, 'error');
                        }

                        this.showResponseErrorMessage(error);
                    });
            }
        },

        AddNotifications() {
            NotificationsService.Add(this.notificationData)
                .then(response => {
                    if (response.status == '200') {
                        this.notificationData = response.data;
                        this.pendingChanges = false;
                        this.$router.push({ name: 'notificationsList' }).catch(() => {});

                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            50
                        );
                    }
                })
                .catch(error => {
                    if (!error.response) {
                        this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.retrieveInfo'), 'error');
                    } else if (error.response.status === 400) {
                        this.showMessage(this.$tc('Msg.Error'), error.response.data.errorMessage, 'error');
                    } else if (error.response.status === 500) {
                        this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.ThereWereSomeError'), 'error');
                    } else {
                        this.showMessage(this.$tc('Msg.Error'), error.response.data.errorMessage, 'error');
                    }

                    elemSaveBtn.removeAttribute('disabled');
                    this.showResponseErrorMessage(error);
                });
        },

        EditNotifications() {
            NotificationsService.Update(this.$route.params.id, this.notificationData)
                .then(response => {
                    if (response.status == '200') {
                        this.notificationData = response.data;
                        this.pendingChanges = false;

                        this.$router.push({ name: 'notificationsList' }).catch(() => {});
                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            50
                        );
                    }
                })
                .catch(error => {
                    if (!error.response) {
                        this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.retrieveInfo'), 'error');
                    } else if (error.response.status === 400) {
                        this.showMessage(this.$tc('Msg.Error'), error.response.data.errorMessage, 'error');
                    } else if (error.response.status === 500) {
                        this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.ThereWereSomeError'), 'error');
                    } else {
                        this.showMessage(this.$tc('Msg.Error'), error.response.data.errorMessage, 'error');
                    }
                    elemSaveBtn.removeAttribute('disabled');
                    this.showResponseErrorMessage(error);
                });
        },

        DoAction() {
            !this.$attrs.editMode ? this.AddNotifications() : this.EditNotifications();
        },

        async validateRequired() {
            if (this.$attrs.editMode) return true;
            
            const currentType = this.notificationData.notificationType;
            const response = await NotificationsService.existNotificationType(currentType);
            const exists = response.data;
        
            if (exists) {
                const selectedType = this.notificationTypes.find(opt => opt.value === currentType);
                const typeLabel = selectedType ? selectedType.text : '';

                this.showMessage(
                    this.$tc('Msg.Error'),
                    `${this.$t('notifications.NotifTypeExist')} (${typeLabel})`,
                    'error'
                );
                return false; 
            } else {
                return true;
            }
        },

        SaveOrEdit() {
            const currentType = this.notificationData.notificationType;
            if (!this.$attrs.editMode && !currentType) {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    `${this.$t('notifications.NotifTypeRequired')}`,
                    'error'
                );
                return false;
            }

            this.validateRequired().then(isValid => {
                if (isValid) {
                    this.DoAction();
                }
            });
        },

        checkUserAction() {
            if (elemSaveBtn.disabled) {
                elemSaveBtn.removeAttribute('disabled');
            }
        },

        beforeWindowUnload(e) {
            if (this.pendingChanges) {
                e.preventDefault();
                e.returnValue = '';
            }
        }
    },

    created() {
        EventBus.$on(
            'onChanged',
            function(e) {
                this.pendingChanges = e.Changed;
                this.checkUserAction();
            }.bind(this)
        );
        window.addEventListener('beforeunload', this.beforeWindowUnload);
    },

    mounted() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }
        this.getNotifications();
        setTimeout(
            function() {
                elemSaveBtn = document.getElementById('btn_save_notifications');
                elemSaveBtn.setAttribute('disabled', '');
            },
            50,
            this
        );
    },

    destroyed() {
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    },

    beforeDestroy() {
        window.removeEventListener('beforeunload', this.beforeWindowUnload);
    }
};
</script>
